import type { CommuneNpdc } from '../types/Commune'

/**
 * Pages locales : P0–P3 indexables (sitemap + robots index).
 * Voir localSeoPolicy.ts pour la règle d’indexation et le niveau de contenu.
 */
export function isCommuneSeoUnlocked(commune: CommuneNpdc | undefined): boolean {
  return !!commune?.slug
}
